import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { FileText, ArrowLeft } from "lucide-react"
import { PublicFooter } from "@/components/lgpd/Footer"

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Card><CardContent className="p-6 prose prose-slate dark:prose-invert max-w-none">
    <h2 className="text-xl font-bold mb-3">{title}</h2>
    <div className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed space-y-2">{children}</div>
  </CardContent></Card>
)

const TermosDeUso = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
    <header className="bg-white dark:bg-slate-800 border-b">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="font-bold text-lg">itaCondo</Link>
        <Link to="/"><Button variant="outline" size="sm"><ArrowLeft className="h-4 w-4 mr-1" /> Voltar</Button></Link>
      </div>
    </header>

    <main className="container mx-auto px-4 py-12 max-w-3xl space-y-6">
      <div className="text-center mb-8">
        <div className="inline-flex w-16 h-16 rounded-full bg-blue-100 items-center justify-center mb-4">
          <FileText className="h-8 w-8 text-blue-600" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold">Termos de Uso</h1>
        <p className="text-sm text-slate-500 mt-2">Última atualização: 25/05/2026 — versão 2026-05-25</p>
      </div>

      <Section title="1. Aceitação">
        <p>Ao criar uma conta ou utilizar o itaCondo, você concorda com estes Termos de Uso e com a Política de Privacidade. Se não concorda, não utilize a plataforma.</p>
      </Section>
      <Section title="2. Cadastro e responsabilidades do usuário">
        <p>Você é responsável pela veracidade dos dados informados e pela confidencialidade das suas credenciais. Notifique-nos imediatamente em caso de uso não autorizado.</p>
      </Section>
      <Section title="3. Uso aceitável">
        <p>É vedado: (i) burlar mecanismos de segurança; (ii) tratar dados de terceiros sem base legal; (iii) inserir conteúdo ilícito, ofensivo ou que viole direitos.</p>
      </Section>
      <Section title="4. Propriedade intelectual">
        <p>O software, a marca e o conteúdo do itaCondo pertencem aos seus titulares. O uso da plataforma não transfere quaisquer direitos.</p>
      </Section>
      <Section title="5. Disponibilidade e limitação de responsabilidade">
        <p>Faremos esforços razoáveis para manter o serviço disponível. Não nos responsabilizamos por interrupções decorrentes de força maior, manutenção programada ou ações de terceiros.</p>
      </Section>
      <Section title="6. Tratamento de dados pessoais">
        <p>O tratamento de dados é regido pela <Link to="/politica-privacidade" className="text-blue-600 underline">Política de Privacidade</Link>, em conformidade com a LGPD.</p>
      </Section>
      <Section title="7. Cancelamento">
        <p>Você pode encerrar sua conta a qualquer momento em <Link to="/configuracoes" className="text-blue-600 underline">Configurações → Privacidade e Dados</Link>.</p>
      </Section>
      <Section title="8. Alterações destes Termos">
        <p>Podemos atualizar estes Termos. Mudanças relevantes serão comunicadas por e-mail ou no próprio sistema.</p>
      </Section>
      <Section title="9. Foro">
        <p>Fica eleito o foro da comarca do contratante para dirimir controvérsias.</p>
      </Section>
    </main>

    <PublicFooter />
  </div>
)

export default TermosDeUso
